import { inject } from 'inversify-props';
import { AxiosPromise } from 'axios';

import { Consent } from '@models';
import IAuthService from 'services/IAuthService';


/*************************************************************************************
 * TODO:
 *  implement usage of AuthService GET / POST (PUT ? - implement in AuthService..)
 *
 *************************************************************************************/

class ConsentService {
    @inject() private authService: IAuthService;

    host: string = `${window.location.protocol}//${window.location.host}`;
    api: string = '/api/consent/';

    constructor(api: string = null) {
        if (api) this.api = api;
    }


    // #region Consent
    getSingle(consentItemId: number): AxiosPromise {
        const apiEndpoint = `${this.host}${this.api}?id=${consentItemId}`;
        return this.authService.get(apiEndpoint);
    }

    getAll(): AxiosPromise {
        const apiEndpoint = `${this.api}list`;
        return this.authService.get(apiEndpoint);        
    }

    saveConsent(consent: Consent): AxiosPromise {
        const apiEndpoint = `${this.api}`;
        return this.authService.post(apiEndpoint, consent);
    }

    getRequiredConsents(): AxiosPromise {
        const apiEndpoint = `${this.host}${this.api}required`;
        return this.authService.get(apiEndpoint);
    }
    // #endregion

    // #region ConsentSubscriptions
    getSubscriptions(): AxiosPromise {
        const apiEndpoint = `${this.api}consentsubscription/list`;
        return this.authService.get(apiEndpoint);
    }

    addConsentSubscriptions(consentIds: number[]): AxiosPromise {
        var apiEndpoint = `${this.api}addconsentsubscriptions`;

        let i = 0;
        consentIds.forEach((consentId) => {
            apiEndpoint = apiEndpoint.concat(`${i == 0 ? '?' : '&'}consentIds=${consentId}`);
            i++;
        });

        // should be post instead of get..
        return this.authService.get(apiEndpoint);
    }
    // #endregion

    // #region LegalBase
    fetchLegalBases(): AxiosPromise {
        const apiEndpoint = `${this.api}legalbase/list`;
        return this.authService.get(apiEndpoint);
    }
    // #endregion

    // #region ConsentSources
    fetchConsentSources(): AxiosPromise {
        const apiEndpoint = `${this.api}consentsource/list`;
        return this.authService.get(apiEndpoint);
    }
    // #endregion
}

export default new ConsentService();
